module.exports = __webpack_public_path__ + "img/piggy-bank-01.623126b4.svg";